import { useState } from "react";
import "../addition/addition.css"; // Reuse the same premium styles

export default function MultiplicationConfig({ onStart }) {
  const [modalType, setModalType] = useState(null);

  const [digitSize, setDigitSize] = useState("Single");
  const [numDigits, setNumDigits] = useState(2);
  const [speed, setSpeed] = useState(600);

  return (
    <div className="addition-container">
      <div className="config-card">
        <div className="config-title">Multiplication</div>

        <div className="row clickable" onClick={() => setModalType("digit")}>
          <span>Digit Size</span>
          <span>{digitSize} ▼</span>
        </div>

        <div className="row clickable" onClick={() => setModalType("count")}>
          <span>No. of digits</span>
          <span>{numDigits} ▼</span>
        </div>

        <div className="row">
          <span>Flickering Speed</span>

          <div className="speed-control">
            <button
              onClick={() => setSpeed(Math.max(200, speed - 50))}
              className="speed-btn minus"
            >
              -
            </button>

            <span className="speed-value">{speed} ms</span>

            <button
              onClick={() => setSpeed(Math.min(950, speed + 50))}
              className="speed-btn plus"
            >
              +
            </button>
          </div>
        </div>
      </div>

      <div className="button-group">
        <button
          className="btn-primary"
          onClick={() =>
            onStart({
              digitSize,
              numDigits,
              speed,
              type: "multiplication"
            })
          }
        >
          Start
        </button>
      </div>

      {/* Modal */}
      {modalType && (
        <div className="modal-overlay">
          <div className="modal">
            <div className="modal-header">
              <strong>{modalType === "digit" ? "Digit Size" : "No. of digits"}</strong>
              <p>Option to select</p>
            </div>

            <div className="modal-options">
              {modalType === "digit" &&
                ["Single", "Double", "Triple", "Quad"].map((item) => (
                  <div
                    key={item}
                    className={`option ${digitSize === item ? "selected" : ""}`}
                    onClick={() => {
                      setDigitSize(item);
                      setModalType(null);
                    }}
                  >
                    {item}
                  </div>
                ))}

              {modalType === "count" &&
                Array.from({ length: 9 }, (_, i) => i + 2).map((num) => (
                  <div
                    key={num}
                    className={`option ${numDigits === num ? "selected" : ""}`}
                    onClick={() => {
                      setNumDigits(num);
                      setModalType(null);
                    }}
                  >
                    {num}
                  </div>
                ))}
            </div>

            <div className="cancel" onClick={() => setModalType(null)}>
              Cancel
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
